import { PATH, TITLES } from '@repo/constants';
import { UserPermissionMap } from '@repo/types';
import {
  AlignVerticalSpaceAroundIcon,
  AudioLinesIcon,
  BadgePlusIcon,
  BaggageClaimIcon,
  BookOpenTextIcon,
  BookUserIcon,
  BoxesIcon,
  BriefcaseBusinessIcon,
  BriefcaseMedicalIcon,
  Calendar1Icon,
  CalendarRangeIcon,
  ChartColumnIcon,
  CircleDollarSignIcon,
  ClipboardListIcon,
  ContactIcon,
  EarthIcon,
  EuroIcon,
  FileChartColumnIncreasingIcon,
  FileChartLineIcon,
  FileCogIcon,
  FileSlidersIcon,
  FileSpreadsheetIcon,
  FileStackIcon,
  FileTextIcon,
  FolderKanbanIcon,
  FolderTreeIcon,
  GlobeIcon,
  ImportIcon,
  Layers2Icon,
  ListCheckIcon,
  ListCollapseIcon,
  ListEndIcon,
  NotebookPenIcon,
  NotebookTabsIcon,
  PencilRulerIcon,
  PocketKnifeIcon,
  ProportionsIcon,
  RedoDotIcon,
  RefreshCcwDotIcon,
  RefreshCwIcon,
  ReplaceIcon,
  ScanSearchIcon,
  SearchCheckIcon,
  SpeechIcon,
  UsersIcon,
  WrenchIcon,
} from 'lucide-react';

export const getNavItemsPortal = (permissions?: UserPermissionMap) => {
  return [
    {
      id: 'reports',
      icon: FileTextIcon,
      label: 'Reports',
      children: [
        {
          id: PATH.REPORT_FACTSHEET,
          label: TITLES.FACTSHEET_CREATE,
          path: PATH.REPORT_FACTSHEET,
          allowed: !!permissions?.view_report_factsheet,
          icon: FileTextIcon,
        },
        {
          id: PATH.REPORT_STATEMENT,
          label: TITLES.STATEMENT,
          path: PATH.REPORT_STATEMENT,
          allowed: !!permissions?.view_report_statement,
          icon: FileChartColumnIncreasingIcon,
        },
        {
          id: PATH.REPORT_PORTFOLIO_SUMMARY,
          label: TITLES.PORTFOLIO_SUMMARY,
          path: PATH.REPORT_PORTFOLIO_SUMMARY,
          allowed: !!permissions?.view_report_portfolio_summary,
          icon: FileChartColumnIncreasingIcon,
        },
        {
          id: PATH.REPORT_TRANSACTION,
          label: TITLES.TRANSACTION,
          path: PATH.REPORT_TRANSACTION,
          allowed: !!permissions?.view_report_transaction,
          icon: CircleDollarSignIcon,
        },
        {
          id: PATH.REPORT_DAILY_EXPOSURE,
          label: TITLES.DAILY_EXPOSURE,
          path: PATH.REPORT_DAILY_EXPOSURE,
          allowed: !!permissions?.view_report_daily_exposure,
          icon: FileChartLineIcon,
        },
        {
          id: PATH.REPORT_COMMISSION_REBATE,
          label: TITLES.COMMISSION_REBATE,
          path: PATH.REPORT_COMMISSION_REBATE,
          allowed: !!permissions?.view_report_commission_rebate,
          icon: FileSpreadsheetIcon,
        },
        {
          id: PATH.REPORT_SALES_TRADING,
          label: TITLES.SALES_TRADING,
          path: PATH.REPORT_SALES_TRADING,
          allowed: !!permissions?.view_report_sales_trading,
          icon: FileSpreadsheetIcon,
        },
        {
          id: PATH.REPORT_TURNOVER_BY_REGION,
          label: TITLES.TURNOVER_BY_REGION,
          path: PATH.REPORT_TURNOVER_BY_REGION,
          allowed: !!permissions?.view_report_turnover_by_region,
          icon: FileChartColumnIncreasingIcon,
        },
        {
          id: PATH.ACGMarkup,
          label: TITLES.ACGMarkup,
          path: PATH.ACGMarkup,
          allowed: !!permissions?.view_report_acg_markup,
          icon: FileChartColumnIncreasingIcon,
        },
        {
          id: PATH.ACCOUNT_SUMMARY,
          label: TITLES.ACCOUNT_SUMMARY,
          path: PATH.ACCOUNT_SUMMARY,
          allowed: !!permissions?.view_report_accounts,
          icon: UsersIcon,
        },
        {
          id: PATH.TRADERS_PL,
          label: TITLES.TRADERS_PL,
          path: PATH.TRADERS_PL,
          allowed:
            !!permissions?.view_report_traders_pl_own ||
            !!permissions?.view_report_traders_pl_all,
          icon: FileChartColumnIncreasingIcon,
        },
        {
          id: PATH.REPORT_TIMELINE,
          label: TITLES.TIMELINE,
          path: PATH.REPORT_TIMELINE,
          allowed: !!permissions?.view_report_timeline,
          icon: AudioLinesIcon,
        },
      ],
    },
    {
      id: 'position',
      icon: ListEndIcon,
      label: 'Positions',
      children: [
        {
          id: PATH.OPEN_POSITION,
          label: TITLES.OPEN_POSITION,
          path: PATH.OPEN_POSITION,
          allowed: !!permissions?.view_positions_open_positions,
          icon: ClipboardListIcon,
        },
        {
          id: PATH.TRADE_BLOTTER,
          label: TITLES.TRADE_BLOTTER,
          path: PATH.TRADE_BLOTTER,
          allowed: !!permissions?.view_positions_trade_blotter,
          icon: ListCheckIcon,
        },
      ],
    },
    {
      id: 'configuration',
      icon: WrenchIcon,
      label: 'Configuration',
      children: [
        {
          id: PATH.CLIENT,
          label: TITLES.CLIENTS,
          path: PATH.CLIENT,
          allowed: !!permissions?.view_configuration_clients,
          icon: UsersIcon,
        },
        {
          id: PATH.BROKERS,
          label: TITLES.BROKERS,
          path: PATH.BROKERS,
          allowed: !!permissions?.view_configuration_brokers,
          icon: BookUserIcon,
        },
        {
          id: PATH.MARKETS,
          label: TITLES.MARKETS,
          path: PATH.MARKETS,
          allowed: !!permissions?.view_configuration_markets,
          icon: EarthIcon,
        },
        {
          id: PATH.REGIONS,
          label: TITLES.REGIONS,
          path: PATH.REGIONS,
          allowed: !!permissions?.view_configuration_regions,
          icon: GlobeIcon,
        },
        {
          id: PATH.TRADERS,
          label: TITLES.TRADERS,
          path: PATH.TRADERS,
          allowed: !!permissions?.view_configuration_traders,
          icon: SpeechIcon,
        },
        {
          id: PATH.SECURITIES_DICTIONARY,
          label: TITLES.SECURITIES_DICTIONARY,
          path: PATH.SECURITIES_DICTIONARY,
          allowed: !!permissions?.view_configuration_securities_dictionary,
          icon: NotebookTabsIcon,
        },
        {
          id: PATH.EXCHANGE,
          label: TITLES.EXCHANGES,
          path: PATH.EXCHANGE,
          allowed: !!permissions?.view_configuration_exchanges,
          icon: ReplaceIcon,
        },
        {
          id: PATH.CLIENT_GROUPS,
          label: TITLES.CLIENT_GROUPS,
          path: PATH.CLIENT_GROUPS,
          allowed: !!permissions?.view_configuration_client_groups,
          icon: FolderTreeIcon,
        },
        {
          id: PATH.CREATE_CLIENT,
          label: TITLES.CREATE_CLIENT,
          path: PATH.CREATE_CLIENT,
          allowed: !!permissions?.view_configuration_client_root,
          icon: BriefcaseBusinessIcon,
        },
        {
          id: PATH.CREATE_BROKER,
          label: TITLES.CREATE_BROKER,
          path: PATH.CREATE_BROKER,
          allowed: !!permissions?.view_configuration_broker_root,
          icon: BoxesIcon,
        },
        {
          id: PATH.PRICING,
          label: TITLES.PRODUCT_PRICING,
          path: PATH.PRICING,
          allowed: !!permissions?.view_configuration_product_pricing,
          icon: EuroIcon,
        },
        {
          id: PATH.CLIENT_UNIT_SIZE,
          label: TITLES.CLIENT_UNIT_SIZE,
          path: PATH.CLIENT_UNIT_SIZE,
          allowed: !!permissions?.view_configuration_client_unit_size,
          icon: ProportionsIcon,
        },
        {
          id: PATH.SETTLEMENT_HOLIDAY,
          label: TITLES.TRADE_HOLIDAY,
          path: PATH.SETTLEMENT_HOLIDAY,
          allowed: !!permissions?.view_tools_settlement_holiday,
          icon: CalendarRangeIcon,
        },
      ],
    },
    {
      id: 'trade',
      icon: CircleDollarSignIcon,
      label: 'Trade',
      children: [
        {
          id: PATH.TRADE_SEARCH,
          label: TITLES.TRADE_SEARCH,
          path: PATH.TRADE_SEARCH,
          allowed: !!permissions?.view_trade_search_trade,
          icon: SearchCheckIcon,
        },
        {
          id: PATH.TRADE_DETAIL,
          label: TITLES.TRADE_ENTRY,
          path: PATH.TRADE_DETAIL + '/0',
          allowed: !!permissions?.view_trade_trade_entry,
          icon: BadgePlusIcon,
        },
        {
          id: PATH.CORPORATE_ACTIONS,
          label: TITLES.TRADE_CORPORATE,
          path: PATH.CORPORATE_ACTIONS,
          allowed: !!permissions?.view_trade_corporate_actions,
          icon: BriefcaseBusinessIcon,
        },
        {
          id: PATH.TRADE_CONFIRMATION,
          label: TITLES.TRADE_CONFIRMATION,
          path: PATH.TRADE_CONFIRMATION,
          allowed: !!permissions?.view_trade_trade_confirmation,
          icon: BaggageClaimIcon,
        },
        {
          id: PATH.TRADE_ALLOCATION,
          label: TITLES.TRADE_ALLOCATION,
          path: PATH.TRADE_ALLOCATION,
          allowed: !!permissions?.view_trade_trade_allocation,
          icon: FileStackIcon,
        },
        {
          id: PATH.MARGIN_PROCESSING,
          label: TITLES.TRADE_MARGINPROCESSING,
          path: PATH.MARGIN_PROCESSING,
          allowed: !!permissions?.view_trade_margin_processing,
          icon: AlignVerticalSpaceAroundIcon,
        },
        {
          id: PATH.FEES_BOOKING,
          label: TITLES.FEES_BOOKING,
          path: PATH.FEES_BOOKING,
          allowed: !!permissions?.view_trade_fees_booking,
          icon: PencilRulerIcon,
        },
      ],
    },
    {
      id: 'tool',
      label: 'Tools',
      icon: PocketKnifeIcon,
      children: [
        {
          id: PATH.RECALCULATION,
          label: TITLES.RECALCULATION,
          path: PATH.RECALCULATION,
          allowed: !!permissions?.view_tools_recalculation,
          icon: Calendar1Icon,
        },
        {
          id: PATH.REBALANCE,
          label: TITLES.REBALANCE,
          path: PATH.REBALANCE,
          allowed: !!permissions?.view_tools_rebalance,
          icon: RefreshCwIcon,
        },
        {
          id: PATH.EXTERNAL_CONTACTS,
          label: TITLES.EXTERNAL_CONTACTS,
          path: PATH.EXTERNAL_CONTACTS,
          allowed: !!permissions?.view_tools_external_contacts,
          icon: ContactIcon,
        },
        {
          id: PATH.DOCUMENTATION,
          label: TITLES.DOCUMENTATION,
          path: PATH.DOCUMENTATION,
          allowed: !!permissions?.view_documentation_readonly,
          icon: BookOpenTextIcon,
        },
      ],
    },
    {
      id: 'reconciliation',
      label: 'Reconciliation',
      icon: RefreshCcwDotIcon,
      children: [
        {
          id: PATH.RECONCILIATION,
          label: TITLES.RECONCILIATION,
          path: PATH.RECONCILIATION,
          allowed: !!permissions?.view_reconciliation_reconciliation,
          icon: RedoDotIcon,
        },
        {
          id: PATH.COUNTERPARTY_POSITIONS,
          label: TITLES.COUNTERPARTY_POSITIONS,
          path: PATH.COUNTERPARTY_POSITIONS,
          allowed: !!permissions?.view_reconciliation_counterparty_positions,
          icon: BriefcaseMedicalIcon,
        },
      ],
    },
    {
      id: 'strategy',
      label: 'Strategy',
      icon: ChartColumnIcon,
      children: [
        {
          id: PATH.STRATEGY_PAIR,
          label: TITLES.PAIR_TRADING,
          path: PATH.STRATEGY_PAIR,
          allowed: !!permissions?.view_strategy_pair_trading,
          icon: Layers2Icon,
        },
      ],
    },
    {
      id: 'signal_generator',
      label: 'Technical Indicators',
      icon: AudioLinesIcon,
      children: [
        {
          id: PATH.TECHNICAL_INDICATORS_RSI_PATTERN_RECOGNITION,
          label: TITLES.RSI_PATTERN_RECOGNITION,
          path: PATH.TECHNICAL_INDICATORS_RSI_PATTERN_RECOGNITION,
          allowed:
            !!permissions?.view_technical_indicators_rsi_pattern_recognition,
          icon: AudioLinesIcon,
        },
        {
          id: PATH.TECHNICAL_INDICATORS_RSI_HISTORY,
          label: TITLES.RSI_HISTORY,
          path: PATH.TECHNICAL_INDICATORS_RSI_HISTORY,
          allowed:
            !!permissions?.view_technical_indicators_rsi_pattern_recognition,
          icon: AudioLinesIcon,
        },
      ],
    },
    {
      id: 'regulatory',
      label: 'Regulatory Reporting',
      icon: FileCogIcon,
      children: [
        {
          id: PATH.CHECK_QUANTITIES,
          label: TITLES.CHECK_QUANTITIES,
          path: PATH.CHECK_QUANTITIES,
          allowed: !!permissions?.view_regulatory_reporting_check_quantities,
          icon: FileSpreadsheetIcon,
        },
        {
          id: PATH.MIFID,
          label: TITLES.MIFID_II_FILE,
          path: PATH.MIFID,
          allowed: !!permissions?.view_regulatory_reporting_create_mifid,
          icon: FileSlidersIcon,
        },
      ],
    },
    {
      id: 'file_management',
      label: 'File Management',
      icon: FolderKanbanIcon,
      children: [
        {
          id: PATH.IMPORT_FILE,
          label: TITLES.IMPORT_FILES,
          path: PATH.IMPORT_FILE,
          allowed: !!permissions?.view_file_management_import_files,
          icon: ImportIcon,
        },
        {
          id: PATH.UPLOADED_FILES,
          label: TITLES.UPLOADED_FILES,
          path: PATH.UPLOADED_FILES,
          allowed: !!permissions?.view_file_management_uploaded_files,
          icon: ScanSearchIcon,
        },
      ],
    },
    {
      id: 'counterparties',
      label: 'Counterparties',
      icon: NotebookPenIcon,
      children: [
        {
          id: PATH.VIRTU,
          label: TITLES.VIRTU,
          path: PATH.VIRTU,
          allowed: !!permissions?.view_counterparties_virtu,
          icon: ListCollapseIcon,
        },
        {
          id: PATH.GOLDMAN_SACHS,
          label: TITLES.GOLDMAN_SACHS,
          path: PATH.GOLDMAN_SACHS,
          allowed: !!permissions?.view_counterparties_goldman_sachs,
          icon: ListCheckIcon,
        },
      ],
    },
  ];
};
